import * as React from "react";
import { RootState } from "../reducers/index";
import { useAppSelector } from "../store/index";
import { IInitOptions } from "../interfaces/initoptions";
import OffCanvasForm from "./offcanvasform";
//import { useGetMeetingsQuery } from "../reducers/providerapi";

const Container = () => {
    return (
        <div>
            <OffCanvasForm />
        </div>
    );
};

export default Container;
